import { combineReducers } from "redux";

import { statusAppController } from "../modulos/root/root.controller"
import { usuarioController } from "../modulos/usuario/usuario.controller"
import { procedimentoController } from "../modulos/procedimento/procedimento.controller"
import { pacienteController } from "../modulos/paciente/paciente.controller"
import { atendimentoController } from "../modulos/atendimento/atendimento.controller"

const statusAppState = statusAppController.reducer.reduceState
const usuarioState = usuarioController.reducer.reduceState
const procedimentoState = procedimentoController.reducer.reduceState
const pacienteState = pacienteController.reducer.reduceState
const atendimentoState = atendimentoController.reducer.reduceState


export default combineReducers({
    statusAppState,
    usuarioState,
    procedimentoState,
    pacienteState,
    atendimentoState
});